export default __webpack_public_path__ + "static/media/panel-add-o.1db4cf2e.svg";